import { UIActions, UIActionsContext } from '@tableau/data-catalog-shared';
import * as React from 'react';

// The BrowserTitleUpdateTypes should align with the applicable public helper methods in
// VPC's BrowserTitleService.ts which get called through UIActions
export enum BrowserTitleUpdateType {
  TITLE_WITH_PLACE_ENTITY_NAME = 'TITLE_WITH_PLACE_ENTITY_NAME',
  TITLE_WITH_PLACE_NAME_FUNCTION = 'TITLE_WITH_PLACE_NAME_FUNCTION',
  TITLE_WITH_ENTITY_NAME_AND_SUBSPACE_NAME = 'TITLE_WITH_ENTITY_NAME_AND_SUBSPACE_NAME',
}

type BrowserTitleUpdaterNameAndSubspaceProps = {
  browserTitleUpdateType: BrowserTitleUpdateType.TITLE_WITH_ENTITY_NAME_AND_SUBSPACE_NAME;
  name: string | null;
  subspaceName: string;
};

type BrowserTitleUpdaterNameProps = {
  browserTitleUpdateType: BrowserTitleUpdateType.TITLE_WITH_PLACE_ENTITY_NAME;
  name: string | null;
};

type BrowserTitleUpdaterNameFunctionProps = {
  browserTitleUpdateType: BrowserTitleUpdateType.TITLE_WITH_PLACE_NAME_FUNCTION;
  nameFunction: () => string;
};

type BrowserTitleUpdaterProps = BrowserTitleUpdaterNameProps
  | BrowserTitleUpdaterNameFunctionProps
  | BrowserTitleUpdaterNameAndSubspaceProps;

export class BrowserTitleUpdater extends React.Component<BrowserTitleUpdaterProps> {

  public render() {
    const name: string | null = this.props.browserTitleUpdateType === BrowserTitleUpdateType.TITLE_WITH_PLACE_ENTITY_NAME ||
      this.props.browserTitleUpdateType === BrowserTitleUpdateType.TITLE_WITH_ENTITY_NAME_AND_SUBSPACE_NAME ?
      this.props.name
      : '';
    return (
      <UIActionsContext.Consumer>
        {uiActions =>
          <BrowserTitleUIActionsUpdater
            browserTitleUpdateType={this.props.browserTitleUpdateType}
            uiActions={uiActions}
            name={name}
            nameFunction={this.props.browserTitleUpdateType === BrowserTitleUpdateType.TITLE_WITH_PLACE_NAME_FUNCTION ?
              this.props.nameFunction
              : () => ''}
            subspaceName={this.props.browserTitleUpdateType === BrowserTitleUpdateType.TITLE_WITH_ENTITY_NAME_AND_SUBSPACE_NAME ?
              this.props.subspaceName : ''}
          />
        }
      </UIActionsContext.Consumer>
    );
  }

}

type BrowserTitleUIActionsUpdaterProps = {
  readonly name?: string | null;
  readonly browserTitleUpdateType: BrowserTitleUpdateType
  readonly uiActions: UIActions;
  readonly nameFunction?: () => string;
  readonly subspaceName: string;
};

class BrowserTitleUIActionsUpdater extends React.Component<BrowserTitleUIActionsUpdaterProps> {

  private localIsMounted = false;

  public componentDidMount() {
    this.localIsMounted = true;
    this.updateBrowserTitle();
  }

  public componentDidUpdate(prevProps: BrowserTitleUIActionsUpdaterProps) {
    if (this.props.name !== prevProps.name || this.props.nameFunction !== prevProps.nameFunction ||
      this.props.uiActions !== prevProps.uiActions) {
      this.updateBrowserTitle();
    }
  }

  private updateBrowserTitle() {
    // setTimeout of 0 is used here to ensure that our browser title update gets called after VPC's set default browser title call
    setTimeout(() => {
      if (this.localIsMounted) {
        this.makeUpdateBrowserTitleUiActionsCall();
      }
    }, 0);
  }

  private makeUpdateBrowserTitleUiActionsCall() {
    switch (this.props.browserTitleUpdateType) {
      case BrowserTitleUpdateType.TITLE_WITH_PLACE_ENTITY_NAME: {
        if (this.props.name) {
          this.props.uiActions.setBrowserTitleWithPlaceEntityName(this.props.name);
        }
        break;
      }
      case BrowserTitleUpdateType.TITLE_WITH_PLACE_NAME_FUNCTION: {
        if (this.props.nameFunction) {
          this.props.uiActions.setBrowserTitleWithPlaceNameFunction(this.props.nameFunction);
        }
        break;
      }
      case BrowserTitleUpdateType.TITLE_WITH_ENTITY_NAME_AND_SUBSPACE_NAME: {
        if (this.props.name) {
          this.props.uiActions.setBrowserTitleWithSpaceEntityNameAndTranslatedSubspaceName(this.props.name, this.props.subspaceName);
        }
        break;
      }
      default:
        break;
    }
  }

  public render() {
    return null;
  }

  public componentWillUnmount() {
    this.localIsMounted = false;
  }

}
